import { HttpContextToken } from '@angular/common/http';

// Define a token with a default value of false
export const BYPASS_INTERCEPTOR_ERROR_NOTIFICATIONS = new HttpContextToken<boolean>(() => false);
